import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import {
  ExposureBySEGs,
  ExposureByTask,
  ExposureForSegByOrgLevel,
} from "src/app/models/exposureBySeg.model";

import { Task } from "src/app/models/task.model";

@Component({
  standalone: false,
  selector: "app-seg-details",
  templateUrl: "./seg-details.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./seg-details.component.scss"],
})
export class SegDetailsComponent implements OnInit {
  @Input() selectedSEG: ExposureBySEGs;
  @Input() exposureDetail: ExposureForSegByOrgLevel[];
  @Input() exposureContribution: ExposureByTask[];
  @Input() show: boolean = false;
  @Input() loading: boolean = true;
  @Input() loadingExposureDetail: boolean = true;
  @Input() taskRequestType: 'group' | 'task' = 'group';
  @Input() showSegReport: boolean = true;
  @Input() segTasks: Task[];

  @Output() hideSEGDetailEmit = new EventEmitter<any>();
  @Output() showSEGDetailEmit = new EventEmitter<any>();
  @Output() toggleTaskRequestEmit = new EventEmitter<any>();
  @Output() toggleTaskwithSEGPopupEmit = new EventEmitter<any>();
  @Output() exposureContributionEmit = new EventEmitter<any>();

  showInfo: boolean = false;
  showAllPopup: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  toggleTaskRequest() {
    this.toggleTaskRequestEmit.emit(true);
  }

  hideSEGDetailFn(event: Event) {
    this.show = false;
    this.hideSEGDetailEmit.emit(event);
  }

  showSEGDetailFn(event: Event) {
    this.show = true;
  }

  toggleTaskwithSEGPopup(task: ExposureByTask) {
    this.toggleTaskwithSEGPopupEmit.emit(task);
  }

  sortExposureContribution(sortData: any) {
    this.exposureContribution = this.exposureContribution.sort((a, b) => {
      const aValue = (a as any)[sortData.active];
      const bValue = (b as any)[sortData.active];
      return (
        (aValue < bValue ? -1 : 1) * (sortData.direction === "asc" ? 1 : -1)
      );
    });
    this.exposureContributionEmit.emit(this.exposureContribution);
  }
}
